// extracted by mini-css-extract-plugin
export default {"root":"ImagePreview_root__HInzv","pdf":"ImagePreview_pdf__I7qwH","icon":"ImagePreview_icon__PmHN9"};